export interface IPopupBackOrigin {
  url: string,
  productIds: string[],
}

const POPUP_BACK_ORIGIN_STORAGE_KEY = 'cfr-popup-back-origin';

export const setPopupBackOrigin = (origin: IPopupBackOrigin): void => {
  if (typeof window === 'undefined') {
    return;
  }
  window.sessionStorage.setItem(POPUP_BACK_ORIGIN_STORAGE_KEY, JSON.stringify(origin));
};

const isValidPopupBackOrigin = (value: unknown): value is IPopupBackOrigin => {
  return (
    typeof value === 'object'
    && value !== null
    && typeof (value as IPopupBackOrigin).url === 'string'
    && Array.isArray((value as IPopupBackOrigin).productIds)
  );
};

export const getPopupBackOrigin = (): IPopupBackOrigin | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const raw = window.sessionStorage.getItem(POPUP_BACK_ORIGIN_STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    return isValidPopupBackOrigin(parsed) ? parsed : null;
  } catch {
    return null;
  }
};
